/**
 * Export Progress Modal Styles
 * Design System compatible component styles
 */

.export-progress-modal {
    // Content container
    &__content {
        text-align: center;
        padding: 16px 0;
    }

    // Icon container
    &__icon-container {
        margin-bottom: 24px;
    }

    // Status icons
    &__icon {
        font-size: 48px;

        &--loading {
            color: #1890ff;
        }

        &--success {
            color: #52c41a;
        }

        &--error {
            color: #ff4d4f;
        }
    }

    // Progress bar
    &__progress-bar {
        margin-bottom: 16px;
    }

    // Progress message
    &__message {
        margin-bottom: 8px;

        p {
            font-size: 15px;
            color: #595959;
            margin: 0;
        }
    }

    // Record count
    &__records {
        margin-bottom: 8px;

        p {
            font-size: 13px;
            color: #8c8c8c;
            margin: 0;
        }
    }

    // Batch count
    &__batch {
        p {
            font-size: 13px;
            color: #8c8c8c;
            margin: 0;
        }
    }

    // Error messages
    &__error {
        margin-top: 16px;

        p {
            font-size: 13px;
            color: #ff4d4f;
            margin: 0;
        }
    }

    // Link button (for Google Drive "OPEN FILE")
    &__link-button {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        color: inherit;
        text-decoration: none;

        &:hover {
            color: inherit;
            text-decoration: none;
        }

        .anticon {
            font-size: 14px;
        }
    }
}
